import { setCookie } from 'cookies-next';
import cookiesConstants from '@/constants/cookies.constants';
const setDesktopWidth = (
  setExternalWidth?: React.Dispatch<React.SetStateAction<number>>
) => {
  setCookie(cookiesConstants.COOKIES.WINDOW_WIDTH.name, (993).toString(), {
    path: '/',
    maxAge: 60 * 60,
  });
  if (setExternalWidth) {
    setExternalWidth(993);
  }
};

export default setDesktopWidth;
